// Node imports
import { FreeGameState } from "@quest/murka-games-behavior-panther/dist/";
import { BaseView, dispatcher, ingenuity } from "@quest/base-core";
import { FgCascadingReelPanelView } from "../FreeGame/FgCascadingReelPanelView";
import { FgCascadingReelPanelController } from "../FreeGame/FgCascadingReelPanelController";
import { View } from "../FreeGame/View";
import { TrailView } from "../trailPanel/TrailView";
import { TrailController } from "../trailPanel/TrailController";
import { FgQLinePlayerMessageController } from "../FreeGame/FgQLinePlayerMessageController";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { FgClusterWinFrameView } from "../FgClusterWinFrame/FgClusterWinFrameView";
import { FgClusterWinFrameController } from "../FgClusterWinFrame/FgClusterWinFrameController";
import { FgStackSymbolView } from "../FgStackSymbol/FgStackSymbolView";
import { FgStackSymbolController } from "../FgStackSymbol/FgStackSymbolController";
import { FreeSpinBarControllerFG } from "../FreeGame/FreeSpinBarControllerFG";
import { StickyFramesView } from "../StickyFrames/StickyFramesView";
import { StickyFramesContorller } from "../StickyFrames/StickyFramesContorller";
import { GameParserModel } from "../Platform/GameParserModel";
import { MoneyHuntingView } from "../MoneyHunting/MoneyHuntingView";
import { MoneyHuntingController } from "../MoneyHunting/MoneyHuntingController";
import { SlotEventConstants } from "@quest/slot-core";


export class FreeGameStateGame extends FreeGameState {
  private fgCascadeView: BaseView;
  protected view: View;
  private fgClusterWinFrameView: FgClusterWinFrameView;
  protected fgClusterWinFrameController: FgClusterWinFrameController;
  private winFgStackSymbolView: FgStackSymbolView;
  private winFgStackSymbolController: FgStackSymbolController;
  private stickyView: StickyFramesView;
  private trailView: BaseView;
  private moneyHuntingView: MoneyHuntingView;


  // Overrided to Initialize some features and to fire events
  public init(): void {
    // super.init();

    this.initializeModel();
    this.initializeView();
    this.initializeReelPanel();
    this.initializePayline();
    this.initializeStickyFrameController();
    this.initializeWinReelPresentation();
    this.initializeOverlayWinReelPresentation();
    this.setReelPanelLayering();
    this.initializeController();
    this.initializeBigWinPresentation();
    this.initializePaytable();
    this.initializeIntroOutro();
    this.initializeSound();
    dispatcher.fireEvent(SlotEventConstants.INITIALIZE_FG_MODEL);
    dispatcher.fireEvent(SlotEventConstants.SETUP_FG);  
    this.initializeFgCascadingReelPanelController();
    this.initializeFreeSpinBarController();
    this.initQLinePlayerMessage();
    this.initializeMoneyHuntingController();
    this.initializeTrailController();

    if ((ingenuity.parserModel as GameParserModel).getFreeGameBroken()) {
      dispatcher.fireEvent(SlotEventConstants.SHOW_FREEGAME_VIEW);
    }
    ingenuity.configData.freegameReturning = true;
  }

  // Overrided to subscribe events
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.INITIALIZE_FG_STACK_SYMBOL_WIN, this.initializeFgStackSymbol, this);
    dispatcher.on(eventDispatchers.INITIALIZE_FG_CLUSTER_WIN_FRAME, this.initializeFgClusterWinFrame, this);
  }

  // Overrided to un subscribe events
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.INITIALIZE_FG_STACK_SYMBOL_WIN, this.initializeFgStackSymbol, this);
    dispatcher.off(eventDispatchers.INITIALIZE_FG_CLUSTER_WIN_FRAME, this.initializeFgClusterWinFrame, this);
  }

  // To initialize fg cluster win frame
  private initializeFgClusterWinFrame(): void {
    if (!this.fgClusterWinFrameView) {
      this.fgClusterWinFrameView = new FgClusterWinFrameView(ingenuity.currentGame.cache.getJSON("main_data").ClusterWinFrame);
      this.fgClusterWinFrameController = new FgClusterWinFrameController(this.fgClusterWinFrameView);
      this.winReelpanel.addChildAt(this.fgClusterWinFrameView, this.winReelpanel.children.length);
    }
  }

  // Intialize fg stack symbol
  private initializeFgStackSymbol(): void {
    if (!this.winFgStackSymbolView) {
      this.winFgStackSymbolView = new FgStackSymbolView(ingenuity.currentGame.cache.getJSON("main_data").stackSymbol);
      this.winFgStackSymbolController = new FgStackSymbolController(this.winFgStackSymbolView);
      this.setLayering(this.winFgStackSymbolView);
    }
  }

  private initializeFreeSpinBarController(): void {
    new FreeSpinBarControllerFG(this.view);
  }

  /**
   * To initialized cascade reel view and controller
   */
  private initializeFgCascadingReelPanelController(): void {
    this.fgCascadeView = new FgCascadingReelPanelView(ingenuity.currentGame.cache.getJSON("main_data").cascadingReelPanel);
    this.view.addChild(this.fgCascadeView);
    new FgCascadingReelPanelController(this.view, this.fgCascadeView, this.model);
  }

  private initQLinePlayerMessage(): void {
    new FgQLinePlayerMessageController(this.view)
  }

  // Overrided to destroy free game feature view & controller
  public shutdown(): void {
    this.winFgStackSymbolView && this.winFgStackSymbolView.destroy();
    this.winFgStackSymbolView = null;
    this.winFgStackSymbolController && this.winFgStackSymbolController.destroy();
    this.winFgStackSymbolController = null;
    super.shutdown();
  }
  private initializeStickyFrameController(): void {
    if (this.stickyView) return;
    this.stickyView = new StickyFramesView(ingenuity.currentGame.cache.getJSON("main_data").stickyFrameSymbol);
    this.view.addChild(this.stickyView);
    new StickyFramesContorller(this.stickyView);
    let totalStikcy = (ingenuity.parserModel as GameParserModel).getStickyFramesPosition();
    dispatcher.fireEvent(eventDispatchers.ADD_STICKY_FRMAES_FG, totalStikcy)
  }
  private initializeMoneyHuntingController(): void {
    if (this.moneyHuntingView) return;
    this.moneyHuntingView = new MoneyHuntingView(ingenuity.currentGame.cache.getJSON("main_data").moneyHunting);
    this.view.addChild(this.moneyHuntingView);
    new MoneyHuntingController(this.moneyHuntingView);
  }

  private initializeTrailController(): void {
    this.trailView = new TrailView(ingenuity.currentGame.cache.getJSON("main_data").trailPanel);
    this.view.addChild(this.trailView);
    new TrailController(this.view, this.trailView, this.model);
  }
}
